// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14O2T","right":"Footer_right__l-JcR","buttons":"Footer_buttons__12OFB"};